<script>
    import { wait } from "@/assets/js/util";

    export let dialog;
    export let dialogClass = "";

    let fader = false;

    export const show = () => {
        fader = false;
        if (dialog && !dialog.open) dialog.showModal();
    };

    export const closeDialog = () => {
        if (!fader) return;
        dialog.close();
        fader = false;
    };

    export const close = async () => {
        fader = true;
        // Fallback: if the fade-out animation never fires animationend (element
        // hidden, animations disabled, ...), force-close so the modal can't stay
        // open invisibly and leave the page inert behind its backdrop.
        await wait(400);
        if (fader) {
            if (dialog?.open) dialog.close();
            fader = false;
        }
    };

export const closeImmediate = () => {
    if (dialog?.open) dialog.close();
    fader = false;
};
</script>

<dialog on:animationend={closeDialog} bind:this={dialog} class="shade3 border white--text ma-auto w-500 w100 curve pa-30 dialog {dialogClass}" class:fadeOut={fader}>
    <div class="col gap-50">
        <!-- <div class="row justify-end">
            <button on:click={close}>
                <Icon icon="mdi:close" />
            </button>
        </div> -->
        <slot />
    </div>
</dialog>

<!-- 
<button on:click={dialog.show()}>Open</button>
<Dialog bind:this={dialog}>
    <div class="row center">Hello Jungle</div>
    <div class="row justify-end">
        <button on:click={dialog.close()}>Close</button>
    </div>
</Dialog> -->

<style>
    dialog::backdrop {
        background-color: rgba(0, 0, 0, 0.8);
        animation: fade-in2 0.3s ease;
    }

    dialog {
        animation: fade-in 0.3s ease;
    }

    .fadeOut {
        animation: fade-out 0.3s ease;
    }

    @keyframes fade-in {
        from {
            opacity: 0;
            scale: 0.8;
        }
        to {
            opacity: 1;
            scale: 1;
        }
    }

    @keyframes fade-out {
        from {
            opacity: 1;
            scale: 1;
        }
        to {
            opacity: 0;
            scale: 0.8;
        }
    }

    @keyframes fade-out2 {
        from {
            background-color: rgba(0, 0, 0, 0.8);
        }
        to {
            background-color: rgba(0, 0, 0, 0);
        }
    }
</style>
